module.exports = __webpack_public_path__ + "img/img-f9f42b28.9887a6df.png";